import {
  Typography,
  Box,
  SxProps,
  Theme,
  AppBar,
  Grid,
  Button,
} from "@mui/material";
import Constants from "../../../utils/Constants";
import { FC } from "react";

type Props = {
  sx?: SxProps<Theme>
}

const Footer: FC<Props> = ({ sx }) => {

  const handleClick = () => {
    window.location.href = Constants.COMPANY_LOGO_URL;
  }

  return (
    <footer style={{ backgroundColor: "white", width: "100%" }}>
      <Box 
        sx={sx} 
        boxShadow={"0px -2px 1px rgba(0,0,0,0.1)"}
      >
        <Grid container justifyContent={"center"} alignItems={"center"}>
          <Button
            onClick={handleClick}
          >
            <img 
              src={Constants.COMPANY_LOGO} 
              height={48} 
            />
          </Button>
        </Grid>
        <Typography align="center">{Constants.COPYRIGHT} {/*Constants.APPLICATION_VERSION*/}</Typography>
      </Box>
    </footer>
  );
};

export default Footer;